
import { TweenMax,gsap, Expo } from "gsap/all";
import anime from 'animejs/lib/anime.es.js';
 
export const animateButton =(className: string, yOffset: string) => {
  
  gsap.to(className, 1, {
    y: yOffset,
    ease: Expo.easeInOut, 
  });
}

export const resetAnimation =(className: string, yOffset: string, delay: boolean) => {
  
 setTimeout(() => {
  gsap.to(className,1, {
    y: yOffset,
    ease: Expo.easeInOut, 
  });
 }, delay ? 1500: 300);
}
export const animateSingleProject = () => {
    
 
			TweenMax.from(".aboutUsContainer", 1, {
				y: "50%",
        opacity: 0,
				ease: Expo.ease, 
        delay: 1
			}); 


      TweenMax.from(".contact_details", 2, {
				y: "60",
        opacity: 0,
				ease: Expo.ease, 
        delay: 1.2
			}); 
      // TweenMax.to(".profile_img", 2, {
			// 	y: "-50%",
      //   border: "1px solid green",
			// 	ease: Expo.easeInOut,
			// 	delay: 3.4,
			// }); 
}
  